import Vue from 'vue'
import '../product-description/product-description.vue'

Vue.component('product-detail', {
 props: []
})